<script lang="typescript">
    import Comment from '@components/Comment.svelte'

    export let comments = []
</script>

{#if comments && comments.length}
    <div class="cm-comments">
        {#each comments as comment (comment.id)}
            <Comment comment={comment} />
        {/each}
    </div>
{:else}
    <p class="text-muted"><em>Es sind noch keine Kommentare verfügbar.</em></p>
{/if}
